import { useEffect } from 'react';

export const useMetaTags = (config = {}) => {
  const {
    title = 'Haksaltech | IT Solutions & Networking',
    description = 'Shop the latest IT products, networking solutions, and tech equipment at competitive prices.',
    image = 'https://haksaltech.com/og-image.jpg',
    url = 'https://haksaltech.com',
    type = 'website',
    keywords = 'IT, networking, computers, equipment'
  } = config;

  useEffect(() => {
    // Update title
    document.title = title;

    // Update meta tags
    const updateMetaTag = (name, content, isOG = false) => {
      let tag = document.querySelector(
        isOG ? `meta[property="${name}"]` : `meta[name="${name}"]`
      );
      
      if (!tag) {
        tag = document.createElement('meta');
        isOG ? tag.setAttribute('property', name) : tag.setAttribute('name', name);
        document.head.appendChild(tag);
      }
      
      tag.setAttribute('content', content);
    };

    const updateCanonicalLink = (canonicalUrl) => {
      let canonicalLink = document.querySelector('link[rel="canonical"]');

      if (!canonicalLink) {
        canonicalLink = document.createElement('link');
        canonicalLink.setAttribute('rel', 'canonical');
        document.head.appendChild(canonicalLink);
      }

      canonicalLink.setAttribute('href', canonicalUrl);
    };

    // Standard meta tags
    updateMetaTag('description', description);
    updateMetaTag('keywords', keywords);
    updateMetaTag('robots', 'index,follow');
    updateCanonicalLink(url);

    // Open Graph tags
    updateMetaTag('og:title', title, true);
    updateMetaTag('og:description', description, true);
    updateMetaTag('og:type', type, true);
    updateMetaTag('og:url', url, true);
    updateMetaTag('og:image', image, true);

    // Twitter Card tags
    updateMetaTag('twitter:card', 'summary_large_image');
    updateMetaTag('twitter:title', title);
    updateMetaTag('twitter:description', description);
    updateMetaTag('twitter:image', image);

  }, [title, description, image, url, type, keywords]);
};

export const useJSONLD = (schema) => {
  useEffect(() => {
    if (!schema) return;

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify(schema);
    document.head.appendChild(script);

    return () => {
      if (script.parentNode) {
        script.parentNode.removeChild(script);
      }
    };
  }, [schema]);
};
